import { Base } from "ui/Scripts/source/framework/base";
import { ITaskEditItem, TaskEditItem } from "./taskEditItem";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ITaskEditTaskTypeData, TaskEditTaskTypeData } from "./taskEditTaskTypeData";

export interface ITaskEdit extends ITaskEditTaskTypeData {
    item: ITaskEditItem;
    canUpdateTask: boolean;
    canRemoveTask: boolean;
    canChangeTaskState: boolean;
    canChangeTaskHeaderData: boolean;
    taskTypes: ITaskEditTypeItem[];
    units: IIdTitleNode[];
}

export class TaskEdit extends TaskEditTaskTypeData implements ITaskEdit {
    item: TaskEditItem;
    canUpdateTask: boolean;
    canRemoveTask: boolean;
    canChangeTaskState: boolean;
    canChangeTaskHeaderData: boolean;
    taskTypes: TaskEditTypeItem[];
    units: IdTitleNode[];

    constructor();
    constructor(obj: ITaskEdit);
    constructor(obj?: any) {
        super(obj);
        this.item = new TaskEditItem(obj ? obj.item : null);
        this.canUpdateTask = obj && obj.canUpdateTask || false;
        this.canRemoveTask = obj && obj.canRemoveTask || false;
        this.canChangeTaskState = obj && obj.canChangeTaskState || false;
        this.canChangeTaskHeaderData = obj && obj.canChangeTaskHeaderData || false;
        this.taskTypes = Base.getTypedArray(obj ? obj.taskTypes : null, TaskEditTypeItem);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        const taskType = this.taskTypes.find(i => i.id === this.item.taskTypeId);
        this.item.initializeDataRowsRows(taskType);
    }
}